import React from 'react';
import dva from 'dva';
import { IntlProvider } from 'react-intl';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import createLoading from 'dva-loading';
// import { createLogger } from "redux-logger";
import report from './utils/report';
import Cookie from './utils/cookie';

// import { SnackbarProvider } from 'notistack';
// import 'intl-polyfill';

import './assets/style/base.less';

// models
import Layout from './models/layout';

// routes
import Routes from './router/router';

// 1. Initialize
const data = {
  history: createBrowserHistory(),
  //onAction: createLogger(),
  onError(e) {
    window.console.log(e);
    let msg = e.sagaStack || e.message;
    report('page_error', window.location.pathname, 0, '', msg);
  },
};

const app = dva(data);

// 2. Plugins
app.use(createLoading());

// 3. Model
app.model(Layout);

// 4. Router
app.router(Routes);

// 5. Start
const App = app.start();

// 获取语言配置
const loadI18n = async () => {
  const lanMap = {
    'en-us': 'en-us',
    'es-es': 'es-es',
    'pt-pt': 'pt-pt',
    'zh-hk': 'zh-hk',
    'zh-cn': 'zh-cn',
  };
  const getLan = () => {
    const urlLang = new URLSearchParams(window.location.search).get('language');
    return lanMap[urlLang] || lanMap[window.localStorage.lang] || 'es-es';
  };

  let tmp = window.location.hostname.split('.');
  const lang = getLan();
  Cookie.write({
    name: 'locale',
    value: lang,
    domain: window.location.hostname.replace(tmp.shift() + '.', ''),
  });
  window.localStorage.lang = lang;
  const promise = await new Promise((resolve, reject) => {
    const script = document.createElement('script');
    document.getElementsByTagName('head')[0].appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
    script.src = `https://pro-static.static303.com/static/lang-${lang}.js`;
  });
  console.log('\x1B[32m%s\x1B[0m', '[i18n] file loading complete.');
  const local = await import(`./i18n/${lang}`);

  return local;
};

// Run App
const runApp = async () => {
  const local = await loadI18n();
  const { locale, messages, formats } = local.default;

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      formats={formats}
      onError={(e) => {
        // 覆写其默认报错处理，仅当该语言环境没有数据且未设置默认文案时打印错误信息
        if (!e.descriptor?.defaultMessage) {
          console.error(e);
        }
      }}
    >
      <App />
    </IntlProvider>
  );
};

runApp().then((app) => ReactDOM.render(app, document.getElementById('root')));
